export default __webpack_public_path__ + "static/media/A8.8379ace1.png";